"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeSchema = void 0;
exports.DateTimeSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/date-time.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "DateTime",
    "description": "Date-time",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:date-time"
            ]
        },
        "dateTimeLocal": {
            "type": "string",
            "pattern": "^(?:[0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])T([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$"
        },
        "dateTimeUTC": {
            "type": "string",
            "format": "date-time"
        },
        "isDateOnly": {
            "type": "boolean",
            "description": "Set to true if time information is not known or applicable and only the date part should be presented"
        },
        "targetTimezone": {
            "type": "string",
            "description": "Timezone according to IANA (http://www.iana.org/time-zones) See `zone.tab`",
            "examples": [
                "Europe/Vienna"
            ]
        }
    },
    "required": [
        "dateTimeUTC",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS10aW1lLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMvZGF0ZS10aW1lLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGNBQWMsR0FBRztJQUM1QixLQUFLLEVBQUUsa0VBQWtFO0lBQ3pFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLFVBQVU7SUFDbkIsYUFBYSxFQUFFLFdBQVc7SUFDMUIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sc0JBQXNCO2FBQ3ZCO1NBQ0Y7UUFDRCxlQUFlLEVBQUU7WUFDZixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsc0dBQXNHO1NBQ2xIO1FBQ0QsYUFBYSxFQUFFO1lBQ2IsTUFBTSxFQUFFLFFBQVE7WUFDaEIsUUFBUSxFQUFFLFdBQVc7U0FDdEI7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsU0FBUztZQUNqQixhQUFhLEVBQUUsdUdBQXVHO1NBQ3ZIO1FBQ0QsZ0JBQWdCLEVBQUU7WUFDaEIsTUFBTSxFQUFFLFFBQVE7WUFDaEIsYUFBYSxFQUFFLDRFQUE0RTtZQUMzRixVQUFVLEVBQUU7Z0JBQ1YsZUFBZTthQUNoQjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixhQUFhO1FBQ2IsTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9